import { Button, HStack, Heading, Link, Text, VStack } from "@chakra-ui/react"
import useTranslate from "@pathwright/ux/src/components/lng/useTranslate"
import { useNoteContext } from "./NoteContext"

// Simple confirmation dialog for deleting notes.
function NoteListItemDelete() {
  const { t } = useTranslate()
  const { setNoteSelection, confirmSelection } = useNoteContext()

  const handleDeleteClick = () => {
    confirmSelection()
  }

  const handleCancelClick = () => {
    setNoteSelection({ action: "none" })
  }

  return (
    <VStack
      align="center"
      justify="center"
      p={4}
      pos="absolute"
      inset={0}
      bg="whiteAlpha.600"
      backdropFilter="blur(4px)"
      borderRadius="card"
      w="full"
      overflow="hidden"
    >
      <Heading as="h1" size="md" m={0}>
        {t("notes.list_item_delete.you_sure")}
      </Heading>

      <Text color="gray.600" m={0}>
        {t("notes.list_item_delete.cannot_undo")}{" "}
      </Text>

      <HStack gap={2} className="archive-action">
        <Button
          colorPalette="red"
          variant="solid"
          size="sm"
          onClick={handleDeleteClick}
          className="delete-note"
        >
          {t("notes.list_item_delete.confirm")}
        </Button>

        <Text color="gray.500">{t("notes.list_item_delete.or")}</Text>

        <Button
          asChild
          variant="plain"
          onClick={handleCancelClick}
          className="cancel-delete-note"
          p={0}
        >
          <Link variant="underline">{t("notes.list_item_delete.cancel")}</Link>
        </Button>
      </HStack>
    </VStack>
  )
}

export default NoteListItemDelete
